export const getServerVersion = () => window?.TABTOUCH?.configuration?.serverVersion
